export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14584.e9ec44cb.jpg";